import { render, staticRenderFns } from "./EditExpense.vue?vue&type=template&id=f8766f8e&scoped=true"
import script from "./EditExpense.vue?vue&type=script&lang=js"
export * from "./EditExpense.vue?vue&type=script&lang=js"
import style0 from "./EditExpense.vue?vue&type=style&index=0&id=f8766f8e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8766f8e",
  null
  
)

export default component.exports